import { FirebaseData } from "../General/FirebaseData";
import { LocalData } from "../General/LocalData";
import { PropertyData } from "../Property/PropertyData";
import { Timestamp } from "firebase/firestore";

export class CompanyLicenceData extends FirebaseData {
  status: "active" | "trial" | "inactive" = "inactive";
  allProperties: boolean = false;
  selectedProperties: PropertyData[] = [];

  setup(data: any) {
    if (super.isValidString(data.status)) {
      this.status = data.status;
    }
    if (super.isValidBoolean(data.allProperties)) {
      this.allProperties = data.allProperties;
    }
    // Properties and units
    if (Array.isArray(data.selectedProperties)) {
      this.selectedProperties = [];
      data.selectedProperties.forEach((propertyId: string) => {
        let property = LocalData.properties.addData(propertyId);
        this.selectedProperties.push(property);
      });
    }
    if (data.trialEndDate as Timestamp) {
      try {
        let date = data.trialEndDate.toDate();
        if (date.getTime() > new Date().getTime()) {
          this.status = "trial";
        }
      } catch (error) {}
    }

    super.setup(data);
  }
}
